import customAxios from "../../customAxios";
import { APPROVE_DRIVER, WITHDRAWAL_APPROVE } from "../../routes";

const approveWithdrawal = async (withdrawalId: string, description: string) => {
  const body = {
    withdrawalId,
    description,
  };
  try {
    return (await customAxios.put(WITHDRAWAL_APPROVE, body)).data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER: error });
    return false;
  }
};

export default approveWithdrawal;
